import { makeStyles } from "@material-ui/styles"
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles((theme) => ({
  cell: {
    width: CELL_WIDTHS.VALUE.SMALL,
    minWidth: CELL_WIDTHS.VALUE.SMALL,
    paddingLeft: 4,
    paddingRight: 4,
    "&:not(:last-child) .separatorInner": {
      position: "absolute",
      width: 1,
      right: 0,
      height: "50%",
      backgroundColor: theme.props.border,
      opacity: 0.8,
    },
  },
  narrow: {
    width: CELL_WIDTHS.VALUE.XXSMALL,
    minWidth: CELL_WIDTHS.VALUE.XXSMALL
  },
}));

export default useStyle;
